module.exports = "export default __webpack_public_path__ + &quot;94531135797a0cc3ae8aa9b862f147ed.svg&quot;;"